import directives from '../module';
import {HttpSvcFactory, HttpSvc} from '../../services/HttpSvc';
import {ProjectPageCtrl} from './ProjectPage';
import {MyFollowings} from '../../services/MyFollowings';
import {FollowersSvc} from '../../services/FollowersSvc';
import {Utils} from 'underscore-extensions';

type ProjectChange = {project: ng.IChangesObject<anm.Project>};

export class LikeCtrl implements ng.IComponentController {
    ProjectPageCtrl: ProjectPageCtrl;
    project: anm.Project;
    http: HttpSvc<string>;
    followersSvc: FollowersSvc;

    constructor(private $element: ng.IAugmentedJQuery,
                private $timeout: ng.ITimeoutService,
                private HttpSvc: HttpSvcFactory,
                private MyFollowings: MyFollowings) {
    }

    $onChanges(changes: ProjectChange) {
        if (!changes.project.currentValue || !changes.project.currentValue.id) return;
        if (this.ProjectPageCtrl) {
            this.ProjectPageCtrl.projectPromise.then(this.init.bind(this));
        } else {
            this.init(this.project);
        }
        if (!options.handHeld) {
            this.MyFollowings.init().then(svc => this.followersSvc = svc);
        }
    }

    init(project: anm.Project) {
        this.project = project;
        this.project.likes && this.project.likes.sort((a, b) => a.liked_at - b.liked_at);
        this.http = this.HttpSvc('project', 'like', this.project.id);
    }

    changeLike() {
        if (options.user.anonymous) return;
        return this.isLiker() ? this.unlike() : this.like();
    }

    private like() {
        this.project.likes.unshift({user: options.user, liked_at: Date.now()});
        this.http.securePost();
    }

    private unlike() {
        this.project.likes = this.project.likes.filter(l => l.user.username !== options.user.username);
        this.http.secureDelete();
    }

    private isLiker() {
        return !!_.find(this.project.likes, (l: anm.Like) => l.user.username === options.user.username);
    }
    loaded: boolean = false;

    public load = _.once(() => {
        if (options.handHeld) return;
        this.loaded = true;
        this.$timeout(() => Utils.rAF(() =>
            (this.$element[0].firstChild as HTMLElement).classList.add('popup-opener'))
        );
    });
}

directives.component('like', {
    bindings: {
        project: '<'
    },
    controller: LikeCtrl,
    require: {ProjectPageCtrl: '^?projectPage'},
    templateUrl: require('like.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/LikeDirective.ts